
export class ArrangementPanelObjectContainersControlComponentController {

    static $inject = [ "$scope", "$q", "$User", "$userAssets", "$oeuvresHandler", "Notification", "gameSceneService", "$timeout" ];    
    
    constructor( $scope, $q, $User, $userAssets, $oeuvresHandler, Notification, gameSceneService, $timeout ) {

        $scope.isOpen  = false;
        $scope.loading = true;
            
        $scope.$watch(function() {
            $scope.current_lists = gameSceneService.arrangement.lists || [];
        });

        $scope.toggle = function() {

            if ($scope.isOpen) {
                $scope.isOpen = false;
            } else {
                open();
            }
        };

        function open() {
            $scope.isOpen = true;

            $scope.loading = true;

            if (!$scope.all_lists) {
                $scope.all_lists = fetchAllClientLists().then(function( lists ) {
                    for (var uid in lists) {

                        var list = lists[ uid ];
                        var count = null;

                        try {
                            if (list.with && list.with.oeuvres) count = (count || 0) + Object.keys( list.with.oeuvres || []).length;
                        } catch (e) {}

                        try {
                            if (list.with && list.with.remotes) count = (count || 0) + Object.keys( list.with.remotes || []).length;
                        } catch (e) {}

                        list.$$objects_count = count;
                    }

                    return $scope.all_lists = lists;
                });
            }

            if (!$scope.all_lists__by_client) {
                $scope.all_lists__by_client = $q.when( $scope.all_lists ).then( all_lists => {

                    $scope.all_lists__by_client = {};

                    for (var uid in all_lists) {

                        var list = all_lists[ uid ];
                        var label = $User.clients[ list.client_uid ] ? $User.clients[ list.client_uid ].name : "_";
                        
                        ($scope.all_lists__by_client[ label ] = $scope.all_lists__by_client[ label ] || {})[ uid ] = list;
                    }

                    return $scope.all_lists__by_client;
                });
            }

            return $q.when( $scope.all_lists__by_client ).then(function() {

                $scope.list_selections = $scope.current_lists.reduce(function( obj, uid ) {
                    return obj[uid] = true, obj;
                }, { });

                return $timeout(function() {
                    $scope.loading = false;
                });

            }).catch(function( error ) {
                console.error( error );
                $scope.isOpen = false;
            });
        }

        $scope.applyListSelectionChanges = function( selected_lists ) {

            var current_lists  = $scope.current_lists;
            var selected_lists = Object.keys( $scope.list_selections ).filter(function( uid ) {
                return $scope.list_selections[uid];
            });

            /**
             * @TODO: varmaan pitäisi tehdä jotain enemmänkin?
             * var to_add = selected_lists.filter(function(uid) { return current_lists.indexOf(uid) == -1; });
             * var to_rm  = current_lists.filter(function(uid) { return selected_lists.indexOf(uid) == -1; });
             */

            gameSceneService.arrangement.lists = angular.copy( selected_lists );

            $scope.isOpen = false;

            return $scope.refreshArrangementFromObjectContainers();
        };

        $scope.refreshArrangementFromObjectContainers = function() {

            return solveNeededObjectChangesFromLinkedObjectContainers().then(function( result ) {

                var to_add = result.to_add || [];
                var to_rm  = result.to_rm  || [];

                /** Ei haluta tehdä teosvalintojen poistoa automaattisesti! */
                to_rm = [];

                if (to_add.length + to_rm.length == 0) return;

                var req_json = { 
                    add : to_add.reduce(function( o, uid ) { return o[uid] = true,  o; }, {}),
                    rm  :  to_rm.reduce(function( o, uid ) { return o[uid] = false, o; }, {})
                };

                if (to_add.length == 1) {
                    if (!window.confirm( "Sommitelmasta puuttuu yksi teos. Haluatko lisätä ja jatkaa?" )) return;
                } else {
                    if (!window.confirm( "Sommitelmasta puuttuu " + to_add.length + " teosta. Haluatko lisätä ja jatkaa?" )) return;
                }

                return req_json;


                /**
                 * Tehdään kysely näin koodarin laiskuussyistä.
                 */
                // req_json  = JSON.stringify( req_json );
                // var res_json = window.prompt( "Toteutetaanko näin?", req_json );
                // if (res_json) return JSON.parse( res_json );
                
            }).then(function( result ) {

                if (!result) return;

                var prms = [];
                
                var to_add = Object.keys( result.add || [] ).filter(function( uid ) { return result.add[uid]; });

                prms[0] = injectObjectsToArrangementByUids( to_add ).then(function( objects ) {
                    return Object.keys( objects ).map(function( uid ) {
                        return objects[ uid ];
                    });
                });

                for (var uid in result.rm) if (result.rm[uid]) {
                    Notification.warning("Removing objects from arrangement automatically not implemented!");
                    break;
                }

                return $q.all( prms );

            }).then(function( result ) {

                if (!result) return;

                var added = result[0], removed = result[1];

                if (added.length == 1) {
                    Notification.success( "1 teos lisätty!" );
                } else if (added.length > 1) {
                    Notification.success( added.length + " teosta lisätty!" );
                }

            }).catch(function( error ) {

                console.error( error );

                Notification.error( "Unable to refresh arrangement object from object containers!" );
            });
        };

        function solveNeededObjectChangesFromLinkedObjectContainers() {

            var prms = [], supposed_objects = {}, current_objects_arr = Object.keys( $oeuvresHandler.oeuvres );

            // Pakotetaan listamuistin tyhjennys
            if (false) try {
                (gameSceneService.arrangement.lists || []).forEach(function( list_uid ) {
                    var list = $userAssets.assets.clients_lists[ list_uid ];
                    if (list) {
                        try { delete $userAssets.assets.clients[ list.client_uid ]; } catch (e) {}
                        try { delete $userAssets.assets.clients_lists[ list_uid ]; } catch (e) {}
                    }
                });
            } catch(e) {}

            (gameSceneService.arrangement.lists || []).forEach(function( list_uid ) {
                prms.push( solveClientListClient( list_uid ).then(function( list ) {
                    console.log( list_uid, "->", list );
                    if (list) {
                        for (var i in list.with.oeuvres) {
                            supposed_objects[ list.with.oeuvres[i].uid ] = list.with.oeuvres[i];
                        }
                    }
                }));
            });

            return $q.all( prms ).then(function() {

                var supposed_objects_arr = Object.keys( supposed_objects );

                return {
                    to_add: supposed_objects_arr.filter(function( uid ) { return  current_objects_arr.indexOf(uid) == -1; }),
                    to_rm:   current_objects_arr.filter(function( uid ) { return supposed_objects_arr.indexOf(uid) == -1; })
                };
            });
        }

        function injectObjectsToArrangementByUids( all_uids ) {

            var objects = {};
            var oeuvres = {};

            return $q.when( all_uids.filter(function( uid ) {
                return [ "92" ].indexOf( uid.substr( 0, 2 )) != -1;
            })).then(function( all_uids ) {

                var couids_arrs = [], maxuids = 10;

                for (var i = 0; i < all_uids.length; i++) {
                    if (all_uids[i].substr(0,2) == "92") {

                        if (couids_arrs[0]) {
                            if (couids_arrs[0].length >= maxuids) couids_arrs.unshift([]);
                        } else {
                            couids_arrs[0] = [];
                        }

                        couids_arrs[0].push( all_uids[i] );
                    }
                }

                // Ladataan varmuuden vuoksi tiedot palvelimelta uudestaan täydessä mitassaan, sillä ei haluta olettaa että saadaan kaikki tarvittava
                return $q.all( couids_arrs.map(function( arr ){
                    return $ApiHandler.get( "/clients/oeuvres", {
                        "clients_oeuvres_uids" : arr.join(","),
                        "with"                 : "oeuvre,images,artist,client_artist",
                        "filters"              : "onlydata,onlyattrs"
                    }).then(function( response ){
                        for ( var uid in response.data) oeuvres[uid] = response.data[uid];
                    })
                }));
            })
            .then(function() {
                return $oeuvresHandler.addPaintings( oeuvres );
            })
            .then(function(all_oeuvres) {

                for (var uid in oeuvres) {
                    if (all_oeuvres[ uid ]) {
                        gameSceneService.addOeuvre( oeuvres[ uid ] = all_oeuvres[ uid ]);
                    } else delete oeuvres[ uid ];
                }

                return oeuvres;
            });
        }


        function solveClientListClient( list_uid ) {
            return $q.when( $userAssets.assets.clients_lists[ list_uid ] || fetchAllClientLists().then(function( all_lists ) {
                return all_lists[ list_uid ];
            }));
        }

        function fetchAllClientLists() {
            return $userAssets.getClients().then(function( clients ) {
                var prms = [], errors = [];

                for (var client_uid in clients) prms.push( $userAssets.getClientLists( client_uid ).catch(function( error ){ errors.push( error ); }));

                return $q.all( prms ).then(function( results ) {

                    if (errors.length > 0) Notification.warning( "Kaikkia listoja ei välttämättä saatu noudettua!" );
                            
                    return angular.extend.apply( null, [{}].concat( results ));
                });
            });
        }
    }
}

export const ArrangementPanelObjectContainersControlComponent = {
    templateUrl: "templates/components/arrangement-panel-object-containers-control.html",
    controller: ArrangementPanelObjectContainersControlComponentController
};
